import React, { useState } from 'react';
import { useTranslation } from '../../../../i18n';

export interface WhosOnImagePlayerProps {
  imageUrl: string;
  fallbackImageUrl?: string;
  timeLimit: number;
  onSubmit: (answer: string, points?: number) => void;
  disabled?: boolean;
}

/**
 * Player view: image is only shown on the host screen. Here we only show the answer form.
 */
export const WhosOnImagePlayer: React.FC<WhosOnImagePlayerProps> = ({
  onSubmit,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const [answer, setAnswer] = useState('');

  const handleSubmit = () => {
    const trimmed = answer.trim();
    if (trimmed) onSubmit(trimmed);
  };

  return (
    <div style={{ textAlign: 'center', padding: '1rem', width: '100%' }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <style>{`
          .whos-on-image-input::placeholder {
            font-size: 0.9rem;
            letter-spacing: 0;
            text-transform: none;
          }
        `}</style>
        <input
          type="text"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          placeholder={t('bonus.player.whosOnImagePlaceholder')}
          disabled={disabled}
          autoFocus
          autoComplete="off"
          className="whos-on-image-input"
          style={{
            width: '100%',
            padding: '1.2rem',
            fontSize: '1.5rem',
            fontFamily: 'monospace',
            textAlign: 'center',
            letterSpacing: '0.1em',
            background: 'linear-gradient(135deg, rgba(var(--color-primary-rgb), 0.08) 0%, rgba(var(--color-secondary-rgb), 0.14) 100%)',
            border: '2px solid rgba(var(--color-secondary-rgb), 0.35)',
            borderRadius: '15px',
            color: 'var(--text-primary)',
            outline: 'none',
          }}
        />
      </div>
      <button
        type="button"
        onClick={handleSubmit}
        disabled={disabled || !answer.trim()}
        className="button"
        style={{
          width: '100%',
          background: answer.trim() && !disabled
            ? 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%)'
            : 'var(--surface-answer-disabled)',
          color: answer.trim() && !disabled ? 'var(--text-on-primary)' : 'var(--text-secondary)',
          border: answer.trim() && !disabled ? 'none' : '1px solid rgba(var(--color-secondary-rgb), 0.24)',
          opacity: 1,
          cursor: answer.trim() && !disabled ? 'pointer' : 'not-allowed',
        }}
      >
        {t('gameplay.submitAnswer')}
      </button>
    </div>
  );
};
